import { useMemo } from 'react';
import { useLocation, useMatches } from 'react-router';
import { resolveContentGroupFromPathname } from '@/lib/analytics/content-group';
import {
    resolveRouteContentGroup,
    resolveRoutePageTitle,
    type AnalyticsPageTitle,
    type RouteDataWithAnalytics,
} from '@/lib/analytics/route-analytics';

/** Resolves the GA4 content_group for the active route, with a pathname fallback. */
export function usePageContentGroup(): string | undefined {
    const matches = useMatches() as Array<{ data?: RouteDataWithAnalytics }>;
    const { pathname } = useLocation();

    return useMemo(() => {
        return resolveRouteContentGroup(matches) ?? resolveContentGroupFromPathname(pathname);
    }, [matches, pathname]);
}

/**
 * Resolves the analytics page title for the active route (matches the `<title>` tag).
 * Returns `undefined` when the route does not expose one, so callers can fall back to
 * `document.title`.
 */
export function usePageAnalyticsTitle(): AnalyticsPageTitle | undefined {
    const matches = useMatches() as Array<{ data?: RouteDataWithAnalytics }>;

    return useMemo(() => resolveRoutePageTitle(matches), [matches]);
}
